import React, { Component } from "react";
import {
  Icon,
  Row,
  Col,
  Card,
  Modal,
  Select,
  Radio,
  Button,
  Spin,
  DatePicker,
  Checkbox,
  Input,
  message,
  Tooltip,
} from "antd";
import axios from "axios";
import moment from "moment";
import { Translate } from "react-translated";
import F from "../../../Functions";
import DeactivateReviewSchedulerModal from "../parts/DeactivateModalForReviewer";
import {
  GET_RS_USERS_API,
  RS_ALL_AGENCIES_API_URL,
} from "../../../utils/Api_enums";
import { IN, INACTIVE_AGENCY, NO_ASSOCIATED_AGENCY, OWNERSHIP_TRANSFER_FAILED, OWNERSHIP_TRANSFER_SUCCESS, PLEASE_FILL_ALL_REQUIRED_FIELD, SELECT_AGENCY_TO_TRANSFER, SELECT_REVIEW_SCHEDULER, SELECT_USER, TA, TEST_AGENCY } from "../../../utils/Constants";
import AgencyBadge from "../../../Custom-Tooltip/AgencyBadge";

const { TextArea } = Input;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class DashModal extends Component {
  state = {
    loading: true,
    users: [],
    agencies: [],
    agency_ids: [],
    isAllSelected: false,
    from_agency: "",
    agent: "",
    // show_deactivate_rs_modal: false,
    rs_users: [],
    showModalNoAgencyFound: false,
  };

  // API CALL to show deactivate modal based on res where success is true and unclick is false
  checkBeforeUnclickReviewAPI = async () => {
    // shreyas told call this when agencies artray empty so there could be existing b files pending
    try {
      this.setState((prevState) => ({
        ...prevState,
        loading: true,
      }));
      const { data } = await axios.get(
        `/api/v2.0/check_before/unclick_review/${this.props.user.id}`
      );
      //   if (data.success && data.unclick === true) {
      if (data.success && data.unclick === false) {
        // this.setState((prevState) => ({
        //   ...prevState,
        //   show_deactivate_rs_modal: true,
        // }));
        this.props.showDeactivateModalFunc()
      } else if (data.success && data.unclick === true) {
        //   } else if (data.success && data.unclick === true) {
        this.setState((prevState) => ({
          ...prevState,
          showModalNoAgencyFound: true,
        }));
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      this.setState((prevState) => ({
        ...prevState,
        loading: false,
      }));
    }
  };

  // calling the api to get list of rs users
  get_all_active_rs_except_deactivated_user = () => {
    // axios.get("/api/rs_active_users/" + user.id).then((res) => {
    axios.get(GET_RS_USERS_API).then((res) => {
      //   this.setState({
      //     // agencies: res.data,
      //     rs_users: res.data
      //   });
      this.setState((prevState) => ({
        ...prevState,
        rs_users: res.data,
      }));
    });
  };

  // if (this.props.loggedin.old_user_type === "SUPER_ADMIN") api = "/api/rs_agencies?user_type=REVIEWADMIN"

  componentDidMount = () => {
    let allAgency = axios.get(RS_ALL_AGENCIES_API_URL);
    let assocAgency = axios.get(`/api/rs_agencies_assoc/${this.props.user.id}`);
    // let users = axios.get("/api/rs_users")
    let users = axios.get(GET_RS_USERS_API);

    Promise.all([allAgency, assocAgency, users]).then(
      ([allAgency, assocAgency, users]) => {
        let data = this.createAgencyAssociatedList(
          assocAgency.data,
          allAgency.data
        );
        this.setState({
          loading: false,
          agencies: data,
          users: users.data.filter((user) => user.id !== this.props.user.id),
        });

        // only call when  agencies length 0
        if (data.length === 0) {
          this.checkBeforeUnclickReviewAPI();
        }
      }
    );
  };
  componentDidUpdate = (prevProps, prevState) => {
    // Check if the length of agency_ids has changed
    if (prevState.agency_ids.length !== this.state.agency_ids.length) {
      // Compare the length of checked agencies to the total number of agencies
      if (this.state.agency_ids.length === this.state.agencies.length) {
        // If all agencies are selected, set isAllSelected to true
        if (prevState.isAllSelected !== true) {
          this.setState({ isAllSelected: true });

        }
      } else {
        // If not all agencies are selected, set isAllSelected to false
        if (prevState.isAllSelected !== false) {
          this.setState({ isAllSelected: false });
        }
      }
    }
  };



  createAgencyAssociatedList = (assocAgency, allAgency) => {
    let data = [];
    assocAgency.forEach((assoc) => {
      const foundAgency = allAgency.find(
        (agency) => agency.id && agency.id === assoc.agency_id
      );
      if (foundAgency) {
        data.push(foundAgency);
      }
    });
    return data;
  };
  save = () => {
    const { agent, agency_ids, isAllSelected } = this.state;
    const { user } = this.props;
    this.setState({ loading: true })
    if (agency_ids.length > 0 && agent !== "") {
      // this.setState({ loading: true });
      const payload = {
        user_id: user.id,
        new_user_id: agent,
        agency_ids,
        isAllSelected: isAllSelected
      };

      let apiBfile = "/api/v2/rs_transfer_bfiles";
      let apiAgency = "/api/v2/update_rs_agency_assoc";
      // commented as now we setting from layout.js user_type BOBREVIEWADMIN and we have to sent usertype REVIEWADMIN
      // if (this.props.loggedin.old_user_type === "SUPER_ADMIN") {
      apiBfile = `/api/v2/rs_transfer_bfiles?user_type=REVIEWADMIN`;
      apiAgency = `/api/v2/update_rs_agency_assoc?user_type=REVIEWADMIN`;
      // }
      Promise.all([
        axios.post(apiBfile, payload),
        axios.post(apiAgency, payload),
      ])
        .then(([t_bfile, t_agency]) => {
          if (t_bfile.data.success && t_agency.data.success) {
            this.props.hideModal();
            this.props.refresh();
            if (this.state.isAllSelected === true) {
              this.checkBeforeUnclickReviewAPI();
            }
            message.success(
              F.translate(OWNERSHIP_TRANSFER_SUCCESS)
            );
          } else message.error(F.translate(OWNERSHIP_TRANSFER_FAILED));
        })
        .catch(() => {
          message.error(F.translate(OWNERSHIP_TRANSFER_FAILED));
        }).finally(() => {
          this.setState({ loading: false });
        })
    } else {
      message.error(F.translate(PLEASE_FILL_ALL_REQUIRED_FIELD));
      this.setState({ loading: false });
    }
  };

  handleCheckboxChange = (e, agencyId) => {
    const { agency_ids } = this.state;
    const isChecked = e.target.checked;

    if (isChecked) {
      // Add agency ID to the array when checked
      this.setState({ agency_ids: [...agency_ids, agencyId] });
    } else {
      // Remove agency ID when unchecked
      this.setState({ agency_ids: agency_ids.filter((id) => id !== agencyId) });
    }
  };

  handleSelectAll = (e) => {
    const { agencies } = this.state;
    const isChecked = e.target.checked;

    if (isChecked) {
      const allAgencyIds = agencies.map((agency) => agency.id);
      this.setState({
        agency_ids: allAgencyIds,
        isAllSelected: true,
      });
    } else {
      this.setState({
        agency_ids: [],
        isAllSelected: false,
      });
    }
  };

  render() {
    const { agency_ids, isAllSelected, agencies, users, loading } = this.state;
    const { user } = this.props;
    const users_list = [];
    for (var i = 0; i < users.length; i++) {
      // if (users[i].user_type === user.user_type && users[i].id !== user.id) {
      users_list.push(users[i]);
      // }
    }
    return (
      <Modal
        // title={<Translate text={`Transfer B-Files`} />}
        title={<Translate text={`Transfer Ownership`} />}
        visible={this.props.showModal}
        style={{ transform: "translate(0px, -50px)" }}
        onCancel={this.props.hideModal}
        footer={
          <div>
            {agencies.length > 0 && (
              <Button
                loading={loading}
                className="bg-164897 borderRadius-28"
                type="primary" onClick={() => this.save()}>
                <Translate text={`Transfer Ownership`} />
              </Button>
            )}
            <Button
              className="borderRadius-28"
              onClick={() => this.props.hideModal()}>
              <Translate text={`Cancel`} />
            </Button>
          </div>
        }
      >
        <Spin indicator={antIcon} spinning={loading}>
          {agencies.length > 0 && (
            <div className="formBox">
              <div style={{ marginBottom: 10 }}>
                <label>
                  <b>
                    <Translate text={SELECT_AGENCY_TO_TRANSFER} />
                    <span className="asteriskIcon"> *</span>
                    :
                  </b>
                </label>
                <Checkbox
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={this.handleSelectAll}
                >
                  Select All
                </Checkbox>
                {agencies.map((agency, i) => (
                  <label key={i}>
                    <Checkbox
                      type="checkbox"
                      checked={agency_ids.includes(agency.id)}
                      onChange={(e) => this.handleCheckboxChange(e, agency.id)}
                    >
                      <span>
                        {agency.name}

                        <AgencyBadge
                          showTest={agency.test == 1}
                          showInactive={agency.active == 0}
                        />


                      </span>
                    </Checkbox>
                  </label>
                ))}

                {/* <Select defaultValue={''} style={{ width: '100%' }} onChange={(val) => this.setState({ from_agency: val })}>
                                <Option value={''}><Translate text={`Select`} />...</Option>
                                {agencies.map((agency, i) => (
                                    <Option key={i} value={agency.id}>{agency.name}</Option>
                                ))}
                            </Select> */}
              </div>
              <div style={{ marginBottom: 10 }}>
                {/* <span>
                  <Tooltip
                    placement="topLeft"
                    title={
                      "B Files associated with previously assigned agencies will also transfer"
                    }
                  >
                    <Icon type="info-circle" />
                  </Tooltip>
                </span> */}
                <label style={{marginTop:'20px'}}>
                  <b>
                    <Translate text={SELECT_REVIEW_SCHEDULER} />
                    <span className="asteriskIcon"> *</span>
                    :
                  </b>
                </label>
                <Select
                  defaultValue={""}
                  style={{ width: "100%" }}
                  onChange={(val) => this.setState({ agent: val })}
                  showSearch
                  optionFilterProp="children"
                >
                  <Option value={""}>
                    <Translate text={SELECT_USER} />
                  </Option>
                  {users_list.map((user, i) => (
                    <Option key={i} value={user.id}>
                      {user.name}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          )}


          {this.state.showModalNoAgencyFound && (
            <label>
              <b>
                <Translate
                  text={NO_ASSOCIATED_AGENCY}
                />
              </b>
            </label>
          )}
        </Spin>
      </Modal>
    );
  }
}

export default DashModal;



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/parts/delete-rs-user-modal.js